module.exports = __webpack_public_path__ + "media/images/countrysquared/dm-fce4bb094894e9928ad88c28358b615f.svg";